import {
  Directive,
  Input,
  HostBinding
} from '@angular/core';
import { BaseDirective } from '../base/_base.directive';


@Directive({
  selector: '[button]',
  exportAs: 'button'
})
export class ButtonDirective extends BaseDirective {

  /**
   * Bootstrap Button style:
     primary, outline-primary, secondary, outline-secondary, danger
  */
  @Input()
  set style(style: string) {
    if (this.buttonStyle) {
      this.removeClassName(this.getButtonStyle(this.buttonStyle));
    }
    this.buttonStyle = style;
    this.setClassName(this.getButtonStyle(style));
  }

  /**
   * Bootstrap Button size
  */
  @Input()
  set size(size: string) {
    if (this.buttonSize) {
      this.removeClassName(this.getButtonSize(this.buttonSize));
    }
    this.buttonSize = size;
    this.setClassName(this.getButtonSize(size));
  }

  @HostBinding('class.disabled')
  @Input() disabled: boolean = false;

  @HostBinding('class.btn') btnClass: boolean = true;
  @HostBinding('attr.type') buttonType: string = 'button';

  @HostBinding('class.version-2')
  @Input() isVersion2: boolean = false;

  private buttonStyle: string;
  private buttonSize: string;

  private getSizePostfix(size: string) {
    switch (size) {
      case 'large':
        return 'lg';
      case 'medium':
        return 'md';
      case 'small':
        return 'sm';
      case 'xsmall':
        return 'xs';
      default:
        return 'md';
    }
  }

  private getButtonStyle(style: string): string {
    return `btn-${style}`;
  }

  private getButtonSize(size: string): string {
    return `btn-${this.getSizePostfix(size)}`;
  }
}
